export const FK_LAM_TRON_SO_TYPE = {
    TUNG_NHOM_DECIMAL_0: 1,
    TUNG_NHOM_DECIMAL_2: 2,
    TONG_NHOM_DECIMAL_0: 3,
};

export const FOODKID_CONST = {
    FOOD_GROUP: {
        /**
         * Thực phẩm tươi
         */
        FRESH: 1,
        /**
         * Thực phẩm khô
         */
        DRY: 2,
    },
    MEAL: {
        BUA_SANG: 1,
        BUA_TRUA: 2,
        BUA_XE: 3,
        BUA_PHU: 4,
    },
    MEAL_NAME: [
        {
            BUA_SANG: 'Bữa sáng',
            BUA_TRUA: 'Bữa trưa',
            BUA_XE: 'Bữa xế',
            BUA_PHU: 'Bữa phụ',
        },
        {
            BUA_SANG: 'Bữa sáng',
            BUA_TRUA: 'Bữa trưa',
            BUA_XE: 'Bữa chính chiều',
            BUA_PHU: 'Bữa phụ chiều',
        },
    ],
    /** Bước thực hiện */
    STEP: {
        /** Thực đơn */
        THUC_DON: 1,

        /** Phiếu kê chợ */
        PHIEU_KE_CHO: 2,

        /** Phiếu tiếp phẩm */
        PHIEU_TIEP_PHAM: 3,

        /** Thực ăn */
        THUC_AN: 4,

        /** Sổ tính tiền chợ */
        SO_TINH_TIEN_CHO: 5,
    },
    /** In báo cáo */
    PRINT_REPORT: {
        THUC_DON: 1,
        THUC_AN: 2,
    },
    KILOGRAM_ID: 1,
    KILOGRAM_WEIGHT: 1000,

    /** Thẻ kho */
    WAREHOUSE_CARD: {
        /** Phiếu nhập */
        IMPORT: 1,
        /** Phiếu xuất */
        EXPORT: 2,
    },
    SO_KIEM_THUC_DATA_TYPE: {
        THUC_DON: 1,
        THUC_AN: 2,
    },
    SO_SUAT_AN_BUOC_2: {
        /** Nhập tự động */
        NHAP_TU_DONG: 1,
        /** Nhập thủ công */
        NHAP_THU_CONG: 2,
    },
};

export const FK_MEAL = {
    BUA_SANG: 1,
    BUA_TRUA: 2,
    BUA_XE: 3,
    BUA_PHU: 4,
};

export const FK_MEAL_ARR = [
    FK_MEAL.BUA_SANG,
    FK_MEAL.BUA_TRUA,
    FK_MEAL.BUA_XE,
    FK_MEAL.BUA_PHU,
];

export const FK_MEAL_LIST = [
    {
        value: FK_MEAL.BUA_SANG,
        name: 'Bữa sáng',
    },
    {
        value: FK_MEAL.BUA_TRUA,
        name: 'Bữa trưa',
    },
    {
        value: FK_MEAL.BUA_XE,
        name: 'Bữa xế',
    },
    {
        value: FK_MEAL.BUA_PHU,
        name: 'Bữa phụ',
    },
];
